export const gallery = [
  {
    image: '/launchpad/stories/chirpPad/app-1-1.png',
  },
  {
    image: '/launchpad/stories/chirpPad/app-1-2.png',
  },
];

export const about = [
  {
    id: 'ticker',
    item: 'Ticker: $CHPD',
  },
  {
    id: 'blockchain-network',
    item: 'Blockchain Network: Base',
  },
  {
    id: 'total-token-supply',
    item: 'Total Token Supply: 1,000,000,000 CHPD',
  },
  {
    id: 'token-price',
    item: 'Token Price: $0.006 per CHPD',
  },
  {
    id: 'total-token-available',
    item: (
      <>
        Total Tokens Available in this MagicDrop: 1,666,666 CHPD{' '}
        <span className="font-normal">(Worth $10,000)</span>
      </>
    ),
  },
  {
    id: 'contract-address',
    item: (
      <>
        Contract Address (CA): TBD{' '}
        <span className="font-normal">(Will be published by their team prior to TGE)</span>
      </>
    ),
  },
];
